define('lq/pageLoadEventManager',[
    'underscore'
], function (_) {

    var PageLoadEventManager = function () {
        this.events = [];
        this.current = undefined;
    }

    PageLoadEventManager.prototype.scheduleEvent = function (instanceId, event, callback) {
        this.events.push({
            instanceId,
            event,
            callback
        });
        if (this.events.length === 1) {
            this.startEvent();
        }
    };

    PageLoadEventManager.prototype.startEvent = function () {
        var self = this;
        
        if (this.events.length > 0) {
            var started = this.current = this.events[0];
            started.event()
                .then(function (aborted) {
                    // The event may have been aborted (and replaced as current) while it was still running,
                    // a late result of such an event must not complete or shift whatever is running now.
                    if(self.current !== started) return;

                    if(typeof started.callback === "function")
                        started.callback(aborted);

                    self.current = undefined;

                    if (aborted) {
                        self.events = [];
                    } else {
                        self.events.shift();
                        self.startEvent();
                    }
                });
        }
    };

    PageLoadEventManager.prototype.abortEvents = function (instanceId) {
        this.events = _.filter(this.events, function(scheduledEvent) {
            return scheduledEvent.instanceId !== instanceId;
        })
        
        if(this.current && this.current.instanceId === instanceId) {
            this.current = undefined;
            this.startEvent();
        }
    };

    return new PageLoadEventManager();
});

